import { useState } from "react";
import { Link } from "react-router-dom";
import SectionTitle from "@/components/base/SectionTitle";
import { faqItems } from "@/mocks/faq";

export default function HomeFaq() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section className="bg-background-100">
      <div className="container-site py-14 md:py-20">
        <SectionTitle
          eyebrow="常见问题"
          title="关于整理与收藏，你可能想问"
          desc="收集了资源整理与收藏过程中最常见的几个问题，帮助你更快上手使用合集、索引与归档。"
        />
        <div className="grid grid-cols-1 gap-4">
          {faqItems.slice(0, 4).map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-background-200/70 bg-background-50"
            >
              <button
                type="button"
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                onClick={() => setOpenIdx(openIdx === idx ? -1 : idx)}
              >
                <span className="flex items-center gap-3 font-heading text-sm font-semibold text-foreground-900 md:text-base">
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-xs text-secondary-800">
                    Q
                  </span>
                  {item.q}
                </span>
                <i
                  className={`ri-add-line shrink-0 text-xl text-foreground-500 transition-transform ${
                    openIdx === idx ? "rotate-45" : ""
                  }`}
                ></i>
              </button>
              {openIdx === idx && (
                <p className="border-t border-background-200/70 px-5 py-4 text-sm leading-6 text-foreground-600">
                  {item.a}
                </p>
              )}
            </div>
          ))}
        </div>
        <div className="mt-8 text-center">
          <Link to="/faq" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800">
            查看更多常见问题
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}